import { call, put, takeLatest } from 'redux-saga/effects'
import { type ActionType, getType } from 'typesafe-actions'
import { post } from '@/utils/api'
import * as actions from './member.actions'

/* Send email to support
 * ========================================================================== */
function* sendSupportEmailRequest(
  action: ActionType<typeof actions.sendSupportEmailRequest>
) {
  try {
    const { request } = action.payload
    const response: {
      status: number
      message: any
    } = yield call(async () =>
      post(`/members/me/subscriptions/cancellation-requests`, request)
    )

    yield put(actions.sendSupportEmailRequestSuccess(response))
  } catch (error) {
    yield put(actions.sendSupportEmailRequestFailure())
  }
}

export function* watchMemberRequest() {
  yield takeLatest(
    getType(actions.sendSupportEmailRequest),
    sendSupportEmailRequest
  )
}

export default [watchMemberRequest]
